// src/routes/AppRoutes.tsx
import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import HomePage from "../pages/Home";
import LoginPage from "../pages/Login";
import { useUnifiedUser } from "../context/UserContext";

const AppRoutes: React.FC = () => {
  const { isUserLoggedIn } = useUnifiedUser();
  const location = useLocation();

  return (
    <Routes>
      <Route
        path="/auth"
        element={
          isUserLoggedIn ? (
            <Navigate to={location.state?.from || "/subscriptions"} replace />
          ) : (
            <LoginPage />
          )
        }
      />
      <Route path="/subscriptions" element={<HomePage />} />
      <Route path="/" element={<Navigate to="/auth" />} />
    </Routes>
  );
};

export default AppRoutes;
